import { create } from "zustand";
import type * as type from "@vTypes";

interface NurseState {
  fullNurseList: type.FullNurseSchema[];
  setNurseList: (nurses: type.FullNurseSchema[]) => void;
}

export const useNurseStore = create<NurseState>((set) => ({
  fullNurseList: [],
  setNurseList: (nurses) => set({ fullNurseList: nurses }),
}));
